import isEmpty from 'lodash/isEmpty'
import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import subscriptions from 'modules/billing/store/collections/subscriptions'
import Plan from 'modules/billing/store/models/Plan'
import type Subscription from 'modules/billing/store/models/Subscription'

class Plans extends Collection<Plan> {
  constructor(data = []) {
    super(data)
    makeObservable(this, {
      current: computed,
    })
  }

  get cacheKey(): string {
    return 'plans'
  }

  model() {
    return Plan
  }

  get current(): Plan {
    const planId = subscriptions.current.attributes.plan

    const plan = this.find({
      id: planId,
    })

    if (!plan) {
      throw Error(`Error finding plans with id = ${planId}`)
    }

    return plan
  }

  get currentAts(): Plan | undefined {
    const planId = subscriptions.current.attributes.ats_plan

    return this.find({
      id: planId,
    })
  }
}

const singleton: Plans = new Plans()

export const subscriptionPlan = (subscription: Subscription) => {
  const planId = subscription.attributes.plan

  const plan = singleton.find({
    id: planId,
  })

  if (!plan) {
    throw Error(`Plan with ID: ${planId} not found for subscription`)
  }

  return plan
}
const canUpgradeSubscriptionPlan = (subscription: Subscription) => {
  if (subscription.hasScheduledUpdate) return false

  const plan = subscriptionPlan(subscription)

  if (!plan) return false

  return !!plan.attributes.upgrade_plan_id
}

/**
 * Some plans can be changed by clients. Usually are monthly
 * plans that can be changed to yearly plans.
 * This method looks if
 *  1. Current subscription.plan has an upgradePlan associated
 *  2. The client requested the change (self serve upgrade)
 */
export const subscriptionPlanOrScheduledPlan = (subscription: Subscription) => {
  const plan = subscriptionPlan(subscription)

  if (!subscription.hasScheduledUpdate) return plan

  const upgradePlan = subscriptionUpgradePlan(subscription)

  return upgradePlan || plan
}

const subscriptionUpgradePlan = (subscription: Subscription) => {
  const plan = subscriptionPlan(subscription)
  const planId = plan.attributes.upgrade_plan_id

  return singleton.find({
    id: planId,
  })
}
export const subscriptionPriceWithDiscount = (subscription: Subscription) => {
  const plan = subscriptionPlanOrScheduledPlan(subscription)
  const total = plan.monthlyPriceForOneSeat
  const discount = subscription.has('discount') ? subscription.attributes.discount : null

  if (!discount || isEmpty(discount)) return total

  const percent = 100 - discount.percent_off
  const discountAmount = ((percent / 100) * total).toFixed(3)

  return parseFloat(discountAmount)
}
export default singleton
